module.exports = __webpack_public_path__ + "static/media/nursing.43417d34.jpg";